// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".hide-sub-menu[data-v-262b19e1]{display:none}.aib-logo[data-v-262b19e1]{margin:10px 0 3px;max-height:60px}@media (max-width:500px){.aib-logo[data-v-262b19e1]{margin:10px 0 1px;max-height:35px}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
